export default {
  'en-US': {
    currency: {
      style: 'currency', currency: 'USD', currencyDisplay: 'symbol'
    }
  },
  'pt-BR': {
    currency: {
      style: 'currency', currency: 'BRL', currencyDisplay: 'symbol'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/numberFormats.js